import React, { useState, useEffect } from "react";
import Link from "next/link";
import styled from "styled-components";
import Header from "@/components/main/Header";
import Footer from "@/components/main/Footer";
import { useTranslation } from "react-i18next";
import VideoModal from "@/components/products/VideoModal";

export default function LookinBodyWeb() {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  useEffect(() => {
    if (isModalOpen) {
      setVideoUrl("https://www.youtube.com/embed/umx1re3yd2Q?autoplay=1&mute=1&modestbranding=1&rel=0&start=0");
    } else {
      setVideoUrl("");
    }
  }, [isModalOpen]);
  return (
    <>
      <Header />
      <LookinBodyWebWrapper>
        <BannerWrap>
          <Area $width="24%">
            <CloudManageTitle
              data-aos="fade-up"
              data-aos-easing="ease-out"
              data-aos-delay="100"
              data-aos-duration="500"
            >
              {t("menu.products.lookingbody-web.cloud-manage-system")}
            </CloudManageTitle>
            <LookinBodyWebTitle
              data-aos="fade-up"
              data-aos-easing="ease-out"
              data-aos-delay="200"
              data-aos-duration="500"
            >
              {t("menu.products.lookingbody-web")}
            </LookinBodyWebTitle>
            <LookinBodyWebDesc>{t("menu.products.lookingbody-web.cloud-manage-system.desc")}</LookinBodyWebDesc>
            <Button href="/contact/contact-us">{t("menu.products.lookingbody-web.register-today")}</Button>
          </Area>
          <Area $width="25%">
            <ScreenImg src="/products/lookinbodyweb/LookinBody_Web_Banner.webp" />
          </Area>
        </BannerWrap>
        <MediaWrap>
          <MediaImg src="/products/lookinbodyweb/image-94.webp" alt="lookinbody-web" />
          <PlayButton onClick={() => setIsModalOpen(true)}>
            <PlaySpan></PlaySpan>
          </PlayButton>
          <VideoModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} url={videoUrl} />
        </MediaWrap>
        <FeatureWrap>
          <FeatureContentWrap>
            <FeatureImgArea>
              <FeatureImg src="/products/lookinbodyweb/image-205.png" alt="lookinbodyweb-image" />
            </FeatureImgArea>
            <FeatureArea>
              <CloudManageTitle
                data-aos="fade-up"
                data-aos-easing="ease-out"
                data-aos-delay="100"
                data-aos-duration="500"
              >
                {t("menu.products.lookingbody-web.convenient-access")}
              </CloudManageTitle>
              <FeatureTitle data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="200" data-aos-duration="500">
                {t("menu.products.lookingbody-web.feature-1.title")}
              </FeatureTitle>
              <LookinBodyWebDesc>{t("menu.products.lookingbody-web.feature-1.desc")}</LookinBodyWebDesc>
            </FeatureArea>
          </FeatureContentWrap>
          <FeatureContentWrap>
            <FeatureArea>
              <CloudManageTitle
                data-aos="fade-up"
                data-aos-easing="ease-out"
                data-aos-delay="100"
                data-aos-duration="500"
              >
                {t("menu.products.lookingbody-web.data-you-can-trust")}
              </CloudManageTitle>
              <FeatureTitle data-aos="fade-up" data-aos-easing="ease-out" data-aos-delay="200" data-aos-duration="500">
                {t("menu.products.lookingbody-web.feature-2.title")}
              </FeatureTitle>
              <LookinBodyWebDesc>{t("menu.products.lookingbody-web.feature-2.desc")}</LookinBodyWebDesc>
            </FeatureArea>
            <FeatureImgArea>
              <FeatureImg src="/products/lookinbodyweb/Mask-group.png" alt="lookinbodyweb-image" />
            </FeatureImgArea>
          </FeatureContentWrap>
        </FeatureWrap>
        <ConnectWrap>
          <ConnectContent>
            <Area $width="448px">
              <PhoneImg src="/products/lookinbodyweb/Mobile_Application.webp" alt="phone" />
            </Area>
            <Area id="connectDesc" $width="25%">
              <CloudManageTitle
                data-aos="fade-up"
                data-aos-easing="ease-out"
                data-aos-delay="100"
                data-aos-duration="500"
              >
                {t("menu.products.lookingbody-web.mobile-app")}
              </CloudManageTitle>
              <LookinBodyWebTitle
                data-aos="fade-up"
                data-aos-easing="ease-out"
                data-aos-delay="200"
                data-aos-duration="500"
              >
                {t("menu.products.lookingbody-web.stay-connect")}
              </LookinBodyWebTitle>
              <LookinBodyWebDesc>{t("menu.products.lookingbody-web.stay-connect.desc")}</LookinBodyWebDesc>
              <StoreWrap>
                <a href="https://play.google.com/store/search?q=inbody&c=apps&hl=en">
                  <StoreImg src="/products/lookinbodyweb/Google_Play.webp" alt="playstore"></StoreImg>
                </a>
                <a href="https://apps.apple.com/us/app/inbody/id884923678">
                  <StoreImg src="/products/lookinbodyweb/App_Store.webp" alt="appstore"></StoreImg>
                </a>
              </StoreWrap>
            </Area>
          </ConnectContent>
        </ConnectWrap>
      </LookinBodyWebWrapper>
      <Footer />
    </>
  );
}

const LookinBodyWebWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 24px 30px 0px 30px;
`;

const BannerWrap = styled.div`
  width: 100%;
  height: 400px;
  display: flex;
  justify-content: center;
  background-color: white;
  border-radius: 10px;
  @media (max-width: 1000px) {
    padding: 50px;
    flex-wrap: wrap;
    height: auto;
  }
`;

const Area = styled.div<{ $width?: string }>`
  width: ${({ $width }) => $width};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 1000px) {
    width: 100%;

    &#connectDesc {
      padding: 40px;
    }
  }
`;

const CloudManageTitle = styled.p`
  font-size: 1.7rem;
  line-height: 180%;
  color: black;
`;

const LookinBodyWebTitle = styled.p`
  font-size: 3.5rem;
  font-weight: 700;
  color: #971b2f;
  @media (max-width: 1300px) {
    font-size: 2.5rem;
  }
`;
const LookinBodyWebDesc = styled.p`
  padding-bottom: 20px;
  line-height: 150%;
  color: #676767;
  white-space: pre-line;
`;

const Button = styled(Link)`
  width: 156px;
  height: 44px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  color: white;
  border-radius: 20px;
  background-color: black;
  transition: 0.3s ease-out;
  cursor: pointer;

  @media (max-width: 460px) {
    margin: 20px auto 15px auto;
  }

  &:hover {
    background-color: #971b2f;
    transition: 0.3s ease-out;
  }
`;

const Img = styled.img`
  display: block;
  object-fit: contain;
`;

const ScreenImg = styled(Img)`
  width: 468px;
  height: 375px;
  @media (max-width: 1000px) {
    padding: 20px;
  }
  @media (max-width: 550px) {
    width: 100%;
  }
`;

const MediaWrap = styled.div`
  position: relative;
  margin: 50px 0;
`;

const MediaImg = styled(Img)`
  width: 63%;
  margin: auto;
  object-fit: cover;
  position: relative;
  @media (max-width: 1000px) {
    width: 95%;
  }
`;

const PlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  display: inline-block;
  z-index: 999;
  width: 90px;
  height: 90px;
  margin: 0;
  border: 3px solid black;
  border-radius: 50%;
  background-color: rgb(70, 70, 70);
  transform: translate(-50%, -50%);
  cursor: pointer;
  @media (max-width: 1000px) {
    width: 70px;
    height: 70px;
  }
`;

const PlaySpan = styled.span`
  position: relative;
  display: block;
  margin: auto;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 15px solid #fff;
`;

const FeatureWrap = styled.div`
  width: 100%;
  padding-bottom: 44px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const FeatureContentWrap = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  @media (max-width: 1000px) {
    flex-wrap: wrap;
  }
`;

const FeatureArea = styled(Area)`
  width: 50%;
  height: auto;
  padding: 100px;
  border-radius: 10px;
  background-color: white;
  @media (max-width: 1000px) {
    width: 100%;
  }
  @media (max-width: 550px) {
    padding: 50px;
  }
`;

const FeatureTitle = styled(LookinBodyWebTitle)`
  font-size: 2.7rem;
  line-height: 120%;
  @media (max-width: 550px) {
    font-size: 2.2rem;
  }
`;

const FeatureImg = styled(Img)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  background-color: #971b2f;
`;

const FeatureImgArea = styled.div`
  width: 50%;
  height: auto;
  border-radius: 10px;
  overflow: hidden;
  @media (max-width: 1000px) {
    width: 100%;
  }
`;

const ConnectWrap = styled.div`
  width: 100%;
  height: 100%;
  @media (max-width: 1000px) {
    height: auto;
  }
`;

const ConnectContent = styled.div`
  width: 100%;
  height: 798px;
  display: flex;
  justify-content: center;
  gap: 80px;
  border-radius: 10px;
  background-color: white;
  @media (max-width: 1000px) {
    flex-wrap: wrap;
  }
`;

const PhoneImg = styled(Img)`
  width: 448px;
  height: 782px;

  @media (max-width: 1000px) {
    display: block;
    margin: auto;
    margin-top: 20px;
    width: 35%;
  }
`;

const StoreWrap = styled.div`
  width: 460px;
  height: 70px;
  margin-top: 20px;
  display: flex;

  @media (max-width: 1000px) {
    width: 100%;
    gap: 10px;
  }
`;

const StoreImg = styled.img`
  width: 150px;
  object-fit: contain;
  margin-right: 10px;

  @media (max-width: 1000px) {
    width: 100%;
  }
`;
